export const DisplayMode = {
  ALWAYS: 'always',
  ONCE: 'once',
  ONBORADING: 'onboarding'
}
  
export const CustomerTypeState = {
  ALL: 'all',
  ONLINE: 'online',
  LOYALTY: 'loyalty',
  UNBIND: 'unbind'
}
